import { useEffect, useState } from "react";
import ToggleTabs from "../Mod/ModTable/ChartTableToggle";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CreateNewSessionModal from "../Resource/Popup/CreateSessionPopup";
import LgbrTable from "../LGBR/LgbrIndex";

const DataTabs = [
  {
    label: "GENERATION",
    step: 1,
    url: "/demo/merit_engine/simulation-generation",
  },
  { label: "COST", step: 2, url: "/demo/merit_engine/simulation-cost" },
  { label: "BID", step: 3, url: "/demo/merit_engine/simulation-bid" },
];

export default function SimulationModHeader({
  title,
  tabsShow = true,
  activeTab: activeTabProp, // ✅ new prop
  setActiveTab: setActiveTabProp, // ✅ new prop
}: {
  title: string;
  tabsShow?: boolean;
  activeTab?: string; // controlled active tab
  setActiveTab?: (tab: string) => void; // external setter
}) {
  const tabNames = useSelector((state: any) => state.switchTabs.tabNames);
  const location = useLocation();
  const [activeTabInternal, setActiveTabInternal] = useState<string>();
  const [isModalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();

  // Decide which source to use: prop vs local state
  const activeTab = activeTabProp ?? activeTabInternal;
  const setActiveTab = setActiveTabProp ?? setActiveTabInternal;

  useEffect(() => {
    const currentTab = DataTabs.find((tab) =>
      location.pathname.includes(tab.url)
    );
    if (currentTab) {
      setActiveTab(currentTab.label);
    }
  }, [location.pathname, setActiveTab]);

  // useEffect(() => {
  //   if (activeTab === "GENERATION") {
  //     navigate("/demo/merit_engine/simulation-generation");
  //   } else if (activeTab === "COST") {
  //     navigate("/demo/merit_engine/simulation-cost");
  //   } else if (activeTab === "BID") {
  //     navigate("/demo/merit_engine/simulation-bid");
  //   }
  // }, [activeTab, navigate]);

  return (
    <div className="bg-white p-[0.5rem] rounded-xl flex flex-wrap gap-3 justify-between items-center">
      <div className="flex items-center gap-4">
        <button
          onClick={() => setModalOpen(true)}
          className="flex items-center gap-1 text-sm rounded-2xl p-3 bg-[#FFFAF6] text-[#F1935C] font-medium border border-[#F1935C] hover transition transform hover:scale-105"
        >
          + <span>Create a New Session</span>
        </button>
        {tabsShow ? <LgbrTable /> : <></>}
      </div>
      <h2 className="chartHeading !text-lg !font-medium w-100">{title}</h2>
      {tabsShow ? (
        <>
          {DataTabs.length === 1 ? (
            <div className="tab tab-active rounded-lg"></div>
          ) : (
            <ToggleTabs
              activeNavigation={true}
              tabs={DataTabs.map((tab) => tab.label)}
              activeTab={activeTab ?? DataTabs[0].label}
              setActiveTab={setActiveTab}
            />
          )}
        </>
      ) : (
        <div className="w-44"></div>
      )}
      <CreateNewSessionModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
      />
    </div>
  );
}
